// Client Portal — system message banner (shared: VoiceIQ, Admin, App shell).

const MSG_STYLES = {
  info: {
    bg: "bg-blue-50",
    border: "border-blue-200",
    text: "text-blue-800",
    icon: "ℹ",
  },
  warning: {
    bg: "bg-amber-50",
    border: "border-amber-200",
    text: "text-amber-800",
    icon: "⚠",
  },
  error: {
    bg: "bg-red-50",
    border: "border-red-200",
    text: "text-red-800",
    icon: "✕",
  },
  success: {
    bg: "bg-green-50",
    border: "border-green-200",
    text: "text-green-800",
    icon: "✓",
  },
};

export const SystemBanner = ({ message, onDismiss }) => {
  const s = MSG_STYLES[message.message_type] || MSG_STYLES.info;
  return (
    <div
      className={`flex items-start justify-between px-4 py-2.5 border-b ${s.bg} ${s.border} ${s.text}`}
    >
      <span className="text-sm flex items-start">
        <span className="mr-2 font-bold flex-shrink-0">{s.icon}</span>
        {message.content}
      </span>
      <button
        onClick={() => onDismiss(message.id)}
        className={`ml-4 flex-shrink-0 opacity-60 hover:opacity-100 font-bold text-base leading-none ${s.text}`}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};
